
export const customerLabels = {
    customers: 'Customers',
    customer: 'Customer',
    name: 'Name',
    address: 'Address',
}

export default customerLabels;